import * as React from 'react';

const Sk24 = ({ title, titleId, ...props }) => /* @__PURE__ */ React.createElement("svg", { fill: "none", viewBox: "0 0 24 24", width: 24, height: 24, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "#EE1C25", d: "M3 8v8a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V8Z" }), /* @__PURE__ */ React.createElement("path", { fill: "#0B4EA2", d: "M21 8H3v6h18z" }), /* @__PURE__ */ React.createElement("path", { fill: "#fff", d: "M5 6a2 2 0 0 0-2 2v2h18V8a2 2 0 0 0-2-2z" }), /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "#fff",
    d: "M9.325 15.27c-1.076-.518-2.614-1.546-2.614-3.58 0-2.035.097-2.96.097-2.96h5.034s.098.925.098 2.96c0 2.033-1.54 3.062-2.615 3.58"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "#EE1C25",
    d: "M9.326 15c-.987-.475-2.4-1.419-2.4-3.285S7.016 9 7.016 9h4.62s.09.849.09 2.715-1.413 2.81-2.4 3.285"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "#fff",
    d: "M9.536 11.226c.267.004.789.015 1.253-.14 0 0-.013.165-.013.36 0 .193.013.36.013.36-.426-.143-.952-.146-1.253-.142v1.03h-.42v-1.031c-.3-.004-.827 0-1.253.142 0 0 .013-.167.013-.36 0-.194-.013-.36-.013-.36.465.155.986.145 1.253.14v-.647a3 3 0 0 0-.991.143s.012-.166.012-.36-.012-.36-.012-.36c.32.103.654.151.99.142a6 6 0 0 0-.132-.926s.246.019.344.019c.099 0 .344-.02.344-.02a6 6 0 0 0-.131.928c.336.009.67-.04.99-.142 0 0-.012.166-.012.36s.012.36.012.36a3 3 0 0 0-.99-.143z"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "#0B4EA2",
    d: "M9.282 15.612 7.238 13.79s.263-.846.772-.846a.61.61 0 0 1 .553.327s.266-.689.763-.689.763.689.763.689a.61.61 0 0 1 .554-.327c.51 0 .771.846.771.846z"
  }
));
Sk24.Size = 24;
Sk24.Title = "Sk";

export { Sk24 as default };
